import { combineReducers } from "redux";
import {
  SET_TOKEN,
  GET_USER_INFO,
  DASHBOARD_MINE,
  DASHBOARD_DETAILS,
  DASHBOARD_Zone,
  SET_NEW_ZONE,
  SET_NEW_DASHBOARD,
  UPDATE_ZONE,
  SET_DEVICE_WIDGETS_DISJOINED,
  SET_DEVICE_WIDGETS_JOINED,
  SET_ZONE_WIDGETS,
  SET_INVITATION_LIST,
  SET_INVITED_USER,
  SET_INVITED_USER_SETTING,
  SET_NEW_INVITATION,
  SET_FOLIO,
  SET_SUPPORT_TYPE_LIST,
  SET_SUPPORT_MINE,
  SELECTED_ZONE,
  SET_SCHEDULE_LIST,
  SCHEDULE_EDIT,
  SCHEDULE_DELETE,
  RELOCATE_WIDGET,
  RENAME_WIDGET,
  SET_DEVICE_MINE,
  DEVICE_RENAME,
  SET_COMMAND_GENERAL,
  RENAME_DASHBOARD,
  REMOVE_DASHBOARD,
  REMOVE_ZONE,
  SELECTED_DEVICE_MINE,
  SET_ICONS,
  SET_WIDGET_SERIAL_NUMBERS,
  UPDATE_PROFILE_INFO,
} from "./types";

const initialState = {
  empty: "",
  object: {},
  array: [],
  dashboardZones: [],
  dashboardMine: [],
  invitationList: [],
  scheduleList: [],
  zoneWidgets: [],
  deviceMine: [],
};

export const token = (state = initialState.empty, action) => {
  switch (action.type) {
    case SET_TOKEN:
      return action.payload;
    default:
      return state;
  }
};

export const userProfileInfo = (state = initialState.object, action) => {
  switch (action.type) {
    case GET_USER_INFO:
      return action.payload;
    case UPDATE_PROFILE_INFO:
      return {
        ...state,
        name: action.payload.name,
        phone: action.payload.phone,
        image: action.payload.image,
      };
    default:
      return state;
  }
};

export const dashboardMine = (state = initialState.dashboardMine, action) => {
  switch (action.type) {
    case DASHBOARD_MINE:
      return {
        dashboardMine: action.payload,
      };
    case SET_NEW_DASHBOARD:
      return {
        ...state,
        dashboardMine: state.dashboardMine.concat(action.payload),
      };
    case RENAME_DASHBOARD:
      return {
        ...state,
        dashboardMine: state.dashboardMine.map((content) =>
          content.id === action.payload.id
            ? {
                ...content,
                dashboard_caption: action.payload.dashboard_caption,
              }
            : content
        ),
      };
    case REMOVE_DASHBOARD:
      return {
        ...state,
        dashboardMine: state.dashboardMine.filter((content) => {
          return content.id !== action.payload.id;
        }),
      };
    default:
      return state;
  }
};

export const dashboardDetails = (state = initialState.object, action) => {
  switch (action.type) {
    case DASHBOARD_DETAILS:
      return action.payload;
    default:
      return state;
  }
};

export const dashboardZones = (state = initialState.dashboardZones, action) => {
  switch (action.type) {
    case DASHBOARD_Zone:
      return {
        dashboardZones: action.payload,
      };
    case SET_NEW_ZONE:
      return {
        ...state,
        dashboardZones: state.dashboardZones.concat(action.payload),
      };
    case UPDATE_ZONE:
      return {
        ...state,
        dashboardZones: state.dashboardZones.map((content) =>
          content.id === action.payload.id
            ? {
                ...content,
                zone_caption: action.payload.zone_caption,
              }
            : content
        ),
      };
    case REMOVE_ZONE:
      return {
        ...state,
        dashboardZones: state.dashboardZones.filter((content) => {
          return content.id !== action.payload.id;
        }),
      };
    default:
      return state;
  }
};

export const selectedZone = (state = initialState.object, action) => {
  switch (action.type) {
    case SELECTED_ZONE:
      return action.payload;
    default:
      return state;
  }
};

export const deviceWidgets = (state = initialState.array, action) => {
  switch (action.type) {
    case SET_DEVICE_WIDGETS_DISJOINED:
      return action.payload;
    default:
      return state;
  }
};

export const deviceWidgetsJoined = (state = initialState.array, action) => {
  switch (action.type) {
    case SET_DEVICE_WIDGETS_JOINED:
      return action.payload;
    default:
      return state;
  }
};

export const deviceMine = (state = initialState.deviceMine, action) => {
  switch (action.type) {
    case SET_DEVICE_MINE:
      return {
        deviceMine: action.payload,
      };
    case DEVICE_RENAME:
      return {
        ...state,
        deviceMine: state.deviceMine.map((content) =>
          content.serial === action.payload.serial
            ? {
                ...content,
                caption: action.payload.caption,
              }
            : content
        ),
      };
    default:
      return state;
  }
};

export const selectedDeviceMine = (state = initialState.empty, action) => {
  switch (action.type) {
    case SELECTED_DEVICE_MINE:
      return action.payload;
    default:
      return state;
  }
};

export const zoneWidgets = (state = initialState.zoneWidgets, action) => {
  switch (action.type) {
    case SET_ZONE_WIDGETS:
      return {
        zoneWidgets: action.payload,
      };
    case RELOCATE_WIDGET:
      return {
        ...state,
        zoneWidgets: state.zoneWidgets.filter((content) => {
          return content.genome !== action.payload.genome;
        }),
      };
    case RENAME_WIDGET:
      return {
        ...state,
        zoneWidgets: state.zoneWidgets.map((content) =>
          content.genome === action.payload.genome
            ? {
                ...content,
                caption: action.payload.caption,
                property: {
                  ...content.property,
                  2: action.payload.icon,
                  3: action.payload.visible,
                  4: action.payload.configuration,
                },
              }
            : content
        ),
      };
    default:
      return state;
  }
};

export const invitationList = (state = initialState.invitationList, action) => {
  switch (action.type) {
    case SET_INVITATION_LIST:
      return {
        invitationList: action.payload,
      };
    case SET_NEW_INVITATION:
      return {
        ...state,
        invitationList: state.invitationList.concat(action.payload),
      };
    default:
      return state;
  }
};

export const invitedUser = (state = initialState.array, action) => {
  switch (action.type) {
    case SET_INVITED_USER:
      return action.payload;
    default:
      return state;
  }
};

export const invitedUserSetting = (state = initialState.array, action) => {
  switch (action.type) {
    case SET_INVITED_USER_SETTING:
      return action.payload;
    default:
      return state;
  }
};

export const folio = (state = initialState.empty, action) => {
  switch (action.type) {
    case SET_FOLIO:
      return action.payload;
    default:
      return state;
  }
};

export const supportTypeList = (state = initialState.array, action) => {
  switch (action.type) {
    case SET_SUPPORT_TYPE_LIST:
      return action.payload;
    default:
      return state;
  }
};

export const supportMine = (state = initialState.array, action) => {
  switch (action.type) {
    case SET_SUPPORT_MINE:
      return action.payload;
    default:
      return state;
  }
};

export const scheduleList = (state = initialState.scheduleList, action) => {
  switch (action.type) {
    case SET_SCHEDULE_LIST:
      return {
        scheduleList: action.payload,
      };
    case SCHEDULE_EDIT:
      return {
        ...state,
        scheduleList: state.scheduleList.map((content) =>
          content.id === action.payload.id
            ? {
                ...content,
                time: action.payload.time,
                start_date: action.payload.start_date,
                days: action.payload.days,
                once: action.payload.once,
              }
            : content
        ),
      };
    case SCHEDULE_DELETE:
      return {
        ...state,
        scheduleList: state.scheduleList.filter((content) => {
          return content.id !== action.payload.id;
        }),
      };
    default:
      return state;
  }
};

export const commandGeneral = (state = initialState.array, action) => {
  switch (action.type) {
    case SET_COMMAND_GENERAL:
      return action.payload;
    default:
      return state;
  }
};

export const icons = (state = initialState.array, action) => {
  switch (action.type) {
    case SET_ICONS:
      return action.payload;
    default:
      return state;
  }
};

export const widgetSerialNumbers = (state = initialState.array, action) => {
  switch (action.type) {
    case SET_WIDGET_SERIAL_NUMBERS:
      return action.payload;
    default:
      return state;
  }
};

export default combineReducers({
  token,
  userProfileInfo,
  dashboardMine,
  dashboardDetails,
  dashboardZones,
  deviceWidgets,
  deviceWidgetsJoined,
  zoneWidgets,
  invitationList,
  invitedUser,
  invitedUserSetting,
  folio,
  supportTypeList,
  supportMine,
  selectedZone,
  scheduleList,
  deviceMine,
  commandGeneral,
  icons,
  widgetSerialNumbers,
  selectedDeviceMine,
});
